var _defineProperty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty.js");

var _objectWithoutProperties = require("/opt/build/repo/node_modules/@babel/runtime/helpers/objectWithoutProperties.js");

var _excluded = ["size", "color"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _extends() {
  return _extends = Object.assign || function (a) {
    for (var b, c = 1; c < arguments.length; c++) {
      for (var d in b = arguments[c], b) {
        Object.prototype.hasOwnProperty.call(b, d) && (a[d] = b[d]);
      }
    }

    return a;
  }, _extends.apply(this, arguments);
}

var React = require("react");

module.exports = function (a) {
  var _a$size = a.size,
      c = _a$size === void 0 ? "1em" : _a$size,
      _a$color = a.color,
      d = _a$color === void 0 ? "#68b604" : _a$color,
      b = _objectWithoutProperties(a, _excluded);

  return b = _objectSpread(_objectSpread({}, b), {}, {
    style: _objectSpread(_objectSpread({}, b.style ? b.style : {}), {}, {
      width: c,
      height: c
    }, d ? {
      fill: d
    } : {})
  }), /*#__PURE__*/React.createElement("svg", _extends({}, b, {
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.608 80.858c-8.247.029-16.494.142-24.741.142H27.68c11.396-16 22.633-31.146 33.949-46.657-.384-.025-.568-.11-.754-.11-17.851-.002-35.701-.03-53.552-.043-.627 0-.842.146-.837.807.031 3.689.016 7.371.016 11.06 0 1.052.001 1.05 1.066 1.05 9.034 0 18.068-.002 27.102.001.355 0 .712.047 1.257.087L1.781 93.782l.584.032c17.146.001 34.291-.003 51.437.017.701.001.794-.281.791-.866-.018-3.743-.03-7.425.009-11.168.007-.778-.207-.942-.994-.939zm71.635-45.876c-16.172.001-32.344-.021-48.517.031a22.057 22.057 0 00-5.37.684C65.115 37.3 60.12 44.074 60.365 50.552c.026.711.441.448.869.448h24.828c4.179 0 8.357.181 12.536.156 4.555-.028 9.119.156 13.661-.114 4.703-.279 8.459-2.458 11.052-6.477 1.742-2.702 2.514-5.703 2.896-8.854.104-.862-.448-.729-.964-.729zM100.57 56.116c-8.19-.003-16.38-.008-24.57.003-2.639.003-5.18.517-7.504 1.79-5.404 2.962-7.481 7.921-8.119 13.723-.083.766.38.745.905.744 4.312-.007 8.623-.004 12.936-.004 1.464.001 2.929.021 4.393-.004 3.223-.054 6.464.069 9.66-.247 4.157-.412 7.536-2.437 9.939-5.917 1.889-2.736 2.834-5.812 3.163-9.103.096-.965.134-.985-.803-.985zM84.161 77.157c-2.493.016-4.988-.024-7.481.021a25.333 25.333 0 00-3.467.299c-8.957 1.396-12.3 8.892-12.835 15.287-.049.572.157.762.729.75 1.49-.031 2.981-.011 4.473-.011l.004.082c2.026-.089 4.073-.036 6.078-.294 7.531-.97 13.28-7.764 13.223-15.462-.007-.574-.23-.675-.724-.672z",
    fillRule: "evenodd"
  }));
};